/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    object, shape, string,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
    guaranteeContainer: {
        width: '70%',
        margin: '30px auto',
        padding: '20px',
        border: `10px solid ${theme.palette.cms?.white || '#ffffff'}`,
        textAlign: 'center',
        '& h4': {
            margin: 0,
            textAlign: 'center',
        },
    },
});
const GuaranteeBlock = ({ classes, data }) => (
    <div
        className={classes.guaranteeContainer}
        style={{
            borderColor: data.border_color ? data.border_color : '',
            backgroundColor: data?.container_background_color?.color,
            color: data?.font_color?.color,
            border: `${data?.border}px`,
            width: data?.container_width,
        }}
    >
        <h4 style={{ fontSize: `${data?.header_font_size}em` }}>{data.header || ''}</h4>
        <div style={{ fontSize: `${data?.copy_font_size}em` }}>
            <ReactMarkdown
                source={data.copy || ''}
                skipHtml
            />
        </div>
    </div>
);
GuaranteeBlock.propTypes = {
    classes: object.isRequired,
    data: shape({
        copy: string,
        header: string,
    }),
};
GuaranteeBlock.defaultProps = {
    data: {},
};
export default withStyles(styles)(GuaranteeBlock);
